import React, {useState, useEffect} from "react";
import { Autocomplete, Box,  Button,  CircularProgress,  InputLabel, TextField, Typography, useTheme } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SubHeader from "../../../../../components/SubHeader";
import LoanList from "./LoanList";
import styles from "./style";
import Modal from "../../../../../components/Modal";
import dayjs from "dayjs";
import { Download, Add } from "@mui/icons-material";

const LoanViewPage = ({data,  open,handleDownload, setOpen,handleAdd, handleUpdate,total,page,setPage,handleDelete,handleFilter,handleRequest, loading,employeeData, handleEmployee, openAddModal, setOpenAddModal, handleAddLoanPayment, item: loanItem, role}) => {
  const theme = useTheme();
  const [item, setItem] = useState();
  const [change, setChange] = useState(false);
  const [from, setFrom] = useState("");
  const [optionValue, setOptionValue] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [date, setDate ]= useState(dayjs());
  const [repdate, setRepdate ]= useState(dayjs());
  const [paymentDate, setPaymentDate] = useState(dayjs());
  const [paymentAmount, setPaymentAmount] = useState("");
  const [loan, setLoan] = useState("");
  const [repaymentAmount, setrepaymentAmount] = useState("");
  const [numberRepayments, setNumberRepayments] = useState("");
  const [des, setDes] = useState("");
  const [remark, setremark] = useState("");
  const isEmployeeRole = role === "Employee" || role === "employee";

  useEffect(() => {
    if (from === "edit" && item) {
      setOptionValue(item?.employeeDetails?.personalInfo.email || "");
      setRepdate(item.repayStart ? dayjs(item.repayStart): dayjs());
      setDate(item.taxYear ? dayjs(item.taxYear) : dayjs());
      setLoan(item.loanAmt || "");
      setrepaymentAmount(item.repayAmt || "");
      setNumberRepayments(item.numRepay || "");
      setDes(item.desc || "");
      setremark(item.remark || "");
      setEmployeeId(item?.employeeDetails?._id || ""); // Set employeeId if needed
      setChange(false); // Reset change state to false when opening for editing
    }
  }, [item, from]);

  const handleData = () => {
    
    if (from === "edit") {
      handleUpdate(item?._id,employeeId,date,repdate,loan,repaymentAmount,numberRepayments,des,remark)

    } else {
      handleAdd(employeeId,date,repdate,loan,repaymentAmount,numberRepayments,des,remark)


    }

  }

  const handlePaymentAmountChange = (e) => {
    const value = e.target.value;
    
    // Remove any non-digit characters except decimal point (this removes negative signs)
    let numericValue = value.replace(/[^0-9.]/g, '');
    
    // Prevent typing "0" or "0." - these are not allowed
    if (numericValue === '0' || numericValue === '0.') {
      return; // Don't update state
    }

    
    // Allow empty string
    if (numericValue === '') {
      setPaymentAmount('');
      return;
    }
    
    // Check if the value is valid (greater than 1)
    const numValue = parseFloat(numericValue);
    if (!isNaN(numValue)) {
      // Allow if value is > 1, or if user is still typing (e.g., "1." could become "1.5")
      if (numValue > 0 || (numericValue.endsWith('.') && numValue >= 0)) {
        setPaymentAmount(numericValue);
      }
    }
  };

  const handleSavePayment = () => {
    if (paymentAmount && parseFloat(paymentAmount) > 0 && paymentDate) {
      handleAddLoanPayment(loanItem?._id, loanItem?.employeeDetails?._id, parseFloat(paymentAmount), paymentDate.format('YYYY-MM-DD'));
      setPaymentAmount("");
      setPaymentDate(dayjs());
    }
  };

  const handleClosePaymentModal = () => {
    setOpenAddModal(false);
    setPaymentAmount("");
    setPaymentDate(dayjs());
  };
  

  return (
    <>
      <Box px="15px" pt="20px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" sx={styles.heading}>{isEmployeeRole ? "My Loan" : "Loan"}</Typography>
       
        <Box display="flex">
          {role !== "Employee" && (
            <Button
              sx={styles.checkoutBtn}
              onClick={() => setOpenAddModal(true)}
            >
              + Add Loan Payment
            </Button>
          )}
          <Button
              sx={styles.exportBtn}
              onClick={handleDownload}
            >
              <Download />
              Export Pdf
            </Button>
        </Box>
      </Box>
      <Box sx={{ backgroundColor: theme.palette.white.main, m: 2, borderRadius: "20px" }} >
        <SubHeader title={`${loanItem?.employeeDetails?.personalInfo?.firstName} ${loanItem?.employeeDetails?.personalInfo?.surName}`}
          search={true}
          sortBy={true}
          onchange={(e)=>handleFilter(e)}
          filter={handleFilter}
          isShowFilter={false}
          handleSort={(e)=>handleFilter("",e)} />

        <LoanList page={page} total={total} setFrom={setFrom} setPage={setPage} data={data} handleDelete={handleDelete} setItem={setItem} setOpen={setOpen} setChange={setChange}/>

      </Box>
      <Modal open={open}  setOpen={setOpen} btnText={from === "edit" ? "Save Changes" : "Add New"} handleCheck={() => handleData()} title={from === "edit" ? "Edit Loans" : "Create Loans"}
        handleRequest={handleRequest}>
        <Box>
          <Box sx={styles.modalGrid}>
            {from === "edit"?

              <Box sx={{width: {xs:"100%", md: "50%"}, my:1}}>
                <InputLabel sx={styles.label}>Employee Email</InputLabel>
                <TextField
                  value={item?.employeeDetails?.personalInfo?.email}
                  onChange={(e) => { setOptionValue(e.target.value); setChange(true); }}
                  rows={2}
                  sx={styles.reason}
                />
              </Box>


              :
              <Box sx={{width: {xs:"100%", md: "50%"}, my:1}}>

                <Autocomplete
                  id="autocomplete"
                  options={employeeData || []}

                  getOptionLabel={(option) => option?.personalInfo?.email}
                  onInputChange={(event, newInputValue) => {
                    handleEmployee(newInputValue);
                  }}

                  onChange={(event, newValue) => {
                    setOptionValue(newValue?.personalInfo?.email || "");
                    setEmployeeId(newValue?._id)
                    setChange(true);
                  }}

                  renderInput={(params) => (
                    <><InputLabel sx={styles.label}>{"Employee Email"}</InputLabel><TextField
                      {...params}
                      sx={{ ...styles.modalInput, ...styles.inputSpace }}
                      variant="outlined"
                      value={change ? optionValue : item?.employeeDetails?.personalInfo.email || ""}

                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }} /></>
                  )}
                />
              
              </Box>
            }
            <Box sx={styles.modalRight}>
              <InputLabel sx={styles.label}>Loan Tax Year</InputLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box>
                  <DatePicker
                    value={date}
                    slotProps={{
                      field: {
                        readOnly: true
                      }
                    }}
                    // minDate={fromDate}
                    sx={styles.calenderInput}
                    onChange={(newValue) => { setDate(newValue); }}
                  />
                </Box>
              </LocalizationProvider>          </Box>
          </Box>
          <Box sx={styles.modalGrid}>

            <Box sx={{ my: 1 }}>
              <InputLabel sx={styles.label}>Repayment Start Period</InputLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box>
                  <DatePicker
                    value={repdate}
                    slotProps={{
                      field: {
                        readOnly: true
                      }
                    }}
                    // minDate={fromDate}
                    sx={styles.calenderInput}
                    onChange={(newValue) => { setRepdate(newValue); }}
                  />
                </Box>
              </LocalizationProvider>            </Box>
            <Box sx={styles.modalRight}>
              <InputLabel sx={styles.label}>Loan Amount</InputLabel>
              <TextField
                value={change ? loan : item?.loanAmt || ""}
                onChange={(e) => { setLoan(e.target.value); setChange(true); }}
                rows={2}
                sx={styles.reason}
              />
            </Box>
          </Box>
          <Box sx={styles.modalGrid}>

            <Box sx={{width: {xs:"100%", md: "50%"}, my:1}}>
              <InputLabel sx={styles.label}>Repayment Amount</InputLabel>
              <TextField
                value={change ? repaymentAmount : item?.repayAmt || ""}
                onChange={(e) => { setrepaymentAmount(e.target.value); setChange(true); }}
                rows={2}
                sx={styles.reason}
              />
            </Box>
            <Box sx={styles.modalRight}>
              <InputLabel sx={styles.label}>Number of Repayments</InputLabel>
              <TextField
                value={change ? numberRepayments : item?.numRepay || ""}
                onChange={(e) => { setNumberRepayments(e.target.value); setChange(true); }}
                rows={2}
                sx={styles.reason}
              />
            </Box>
          </Box>

          <Box sx={{ my: 1 }}>
            <InputLabel sx={styles.label}>Description</InputLabel>
            <TextField
              value={change ? des : item?.desc || ""}
              onChange={(e) => { setDes(e.target.value); setChange(true); }}
              rows={2}
              sx={styles.reason}
            />
          </Box>
          <InputLabel sx={styles.label}>Remark</InputLabel>
          <TextField
            multiline={true}
            value={change ? remark : item?.remark || ""}
            onChange={(e) => { setremark(e.target.value); setChange(true); }}
            rows={2}
            sx={styles.reason}
          />
        </Box>

      </Modal>

      <Modal
        open={openAddModal}
        setOpen={handleClosePaymentModal}
        disabled={!paymentAmount || parseFloat(paymentAmount) <= 1 || !paymentDate}
        btnText="Save"
        handleCheck={handleSavePayment}
        title="Add Loan Payment"
      >
        <Box>
          <Box sx={styles.modalGrid}>
            <Box sx={{ flex: {xs: "1 1 100%", md: "1 1 50%"}, minWidth: 0, display: "flex", flexDirection: "column" }}>
              <InputLabel sx={styles.label}>Date</InputLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={paymentDate}
                  slotProps={{
                    field: {
                      readOnly: true
                    }
                  }}
                  sx={styles.calenderInput}
                  onChange={(newValue) => { setPaymentDate(newValue); }}
                />
              </LocalizationProvider>
            </Box>
            <Box sx={{ flex: {xs: "1 1 100%", md: "1 1 50%"}, minWidth: 0, display: "flex", flexDirection: "column" }}>
              <InputLabel sx={styles.label}>Amount</InputLabel>
              <TextField
                type="text"
                value={paymentAmount}
                onChange={handlePaymentAmountChange}
                placeholder="Enter amount"
                sx={styles.reason}
                inputProps={{
                  min: 1,
                  step: 0.01
                }}
              />
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default LoanViewPage;
